<template>
  <div class="hello" ref="chartdiv"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4lang_pr_BR from "@amcharts/amcharts4/lang/pt_BR";

am4core.useTheme(am4themes_animated);

export default {
  props: {
    data: {
      default: [],
      type: Array
    },
    unidades: {
      default: [],
      type: Array
    },
    titulo: {
      type: String,
      default: ""
    },
    defaultColor: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    onAppeared: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    let self = this;

    let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu._disposers = new Array();

    chart.language.locale = am4lang_pr_BR;
    chart.paddingRight = 20;
    /*
    let data = [];
    let visits = 10;
    for (let i = 1; i < 366; i++) {
      visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
      data.push({
        date: new Date(2018, 0, i),
        name: "name" + i,
        value: visits
      });
    }
*/
    chart.data = this.data;

    // Create axes
    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "periodo";
    categoryAxis.renderer.cellStartLocation = 0.1;
    //categoryAxis.renderer.cellEndLocation = 0.9;

    if (this.titulo != "") {
      let title = chart.titles.create();
      title.text = this.titulo;
      title.fontSize = 14;
      title.marginBottom = 5;
    }

    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.opposite = false;
    valueAxis.min = 0;
    valueAxis.max = 10;

    let cellSize = 50;
    let grafico_size = cellSize * this.data.length * this.unidades.length + 100;

    console.log("grafico size: " + grafico_size);
    //chart.svgContainer.htmlElement.style.height = "600px";
    chart.svgContainer.htmlElement.style.height =
      grafico_size.toString() + "px";
    // grafico_size.toString() + "px";

    // Create series
    function createSeries(field, name, cor, objvue) {
      console.log("adicionando série ", name);
      //var series = chart.series.push(new am4charts.ColumnSeries());
      var series = new am4charts.ColumnSeries();
      series.showOnInit = false;
      series.dataFields.valueX = field;
      series.dataFields.categoryY = "periodo";
      // categoryAxis.renderer.cellEndLocation = 0.8;
      // series.dataFields.categoryY.marginBottom = "2px";

      series.name = name;

      //series.columns.color = am4core.color(cor);
      //series.stroke = am4core.color(cor);

      if (!objvue.defaultColor) {
        let gradient = new am4core.LinearGradient();
        gradient.addColor(am4core.color(cor).lighten(0.4));
        gradient.addColor(am4core.color(cor));

        series.columns.template.stroke = am4core.color(cor);
        series.columns.template.fill = gradient; //am4core.color(cor);
      }

      series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
      series.columns.template.height = am4core.percent(100);
      series.sequencedInterpolation = true;

      var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{valueX}";
      valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dx = 10;
      valueLabel.label.hideOversized = false;
      valueLabel.label.truncate = false;

      var categoryLabel = series.bullets.push(new am4charts.LabelBullet());
      categoryLabel.label.text = "{name}";
      categoryLabel.label.horizontalCenter = "right";
      categoryLabel.label.dx = -10;
      categoryLabel.label.fill = am4core.color("#fff");
      categoryLabel.label.hideOversized = false;
      categoryLabel.label.truncate = false;

      chart.series.unshift(series);
    }

    for (var i = 0; i < this.unidades.length; i++) {
      var item_unidade = this.unidades[i];
      createSeries(
        "value_" + item_unidade.id.toString(),
        item_unidade.nome,
        item_unidade.cor,
        this
      );
    }

    if (this.onAppeared != null) {
      chart.events.on("appeared", function(ev) {
        // console.log("appeared? ");
        setTimeout(function() {
          chart.exporting.getImage("jpg").then(data => {
            //console.log("gerei a data? ");
            //console.log(data);
            self.onAppeared(data, self.index);
            // img = data;
          });
        }, self.index * 400);
      });
    }

    /*
                        let img;

                        // Async
                        img = await chart.exporting.getImage( "png" );

                        // Sync
                

        */

    this.chart = chart;
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};

/*
    let scrollbarX = new am4charts.XYChartScrollbar();

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "periodo";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.cellStartLocation = 0.1;
    categoryAxis.renderer.cellEndLocation = 0.9;

    for (var i = 0; i < this.unidades.length; i++) {
      var item_unidade = this.unidades[i];

      let series = chart.series.push(new am4charts.ColumnSeries());

      //series.setCategoryAxisField("periodo");
      series.dataFields.valueY = "value_" + item_unidade.id.toString();
      series.dataFields.categoryX = "periodo";
      series.name = item_unidade.nome;
      series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";

      series.setColorProperty(item_unidade.cor);
      // series.dataFields.categoryX

      series.tooltipText = "{valueY.value}";
      scrollbarX.series.push(series);
    }

    console.log(scrollbarX);

    //chart.cursor = new am4charts.XYCursor();

    //chart.scrollbarX = scrollbarX;

    //this.chart = chart;
  },
  */

/*
//view-source:http://localhost:8080/julio/controllare_utf8/graph_cliente2.php?periodo_inicio=1/2019&periodo_final=1/2019&id_cliente=1204&ids_unidades=1711,1720,1726,1727,1702,1683,1694,1693,1698,1692,1697,1696&tipo=1&id_modelo=62&id_setor=


 var chartData =  [{"periodo":"Janeiro \/ 2019","value_1711":7.88,"category_1711":"BAFL - Base A\u00c3\u00a9rea de Florian\u00c3\u00b3polis ",
 "value_1720":6.41,"category_1720":"BAFZ - Base A\u00c3\u00a9rea de Fortaleza",
 "value_1726":7.41,"category_1726":"BASV - Sede GAP-SV - Localizado no ALA 14 - Antiga BASV","value_1727":6.61,"category_1727":"BASV (CEMCOHA) - Centro Militar de Conven\u00c3\u00a7\u00c3\u00b5es e Hospedagem","value_1702":9.69,"category_1702":"GAP - SJ (GAP) Antigo GIA-SJ (grupamento de infra da a\u00c3\u00a9reo de SJ) ","value_1683":6.11,"category_1683":"GAP- RJ (HCA) - Hospital Central da Aeron\u00c3\u00a1utica ","value_1694":3.98,"category_1694":"GAP-AF (ALA12) - Antiga BASC (Base a\u00c3\u00a9rea de Santa Cruz)","value_1693":5.44,"category_1693":"GAP-AF (BAAF) - Base a\u00c3\u00a9rea dos Afonsos ","value_1698":4.81,"category_1698":"GAP-AF (BINFAE-AF) - Refeit\u00c3\u00b3rio Batalh\u00c3\u00a3o Infantaria especial dos Afonsos","value_1692":7.27,"category_1692":"GAP-AF (DIRAD) - Diretoria de Administra\u00c3\u00a7\u00c3\u00a3o da Aeron\u00c3\u00a1utica ","value_1697":5.93,"category_1697":"GAP-AF (UNIFA) - Universidade da For\u00c3\u00a7a A\u00c3\u00a9rea","value_1696":5.64,"category_1696":"GAP-AF(HAAF) - Hospital de Aeron\u00c3\u00a1utica dos Afonsos"}] 


     AmCharts.ready(function () {
                           // SERIAL CHART
                           chart<?=$yy?> = new AmCharts.AmSerialChart();
                           chart<?=$yy?>.dataProvider = chartData;
                           chart<?=$yy?>.categoryField = "periodo";
                           chart<?=$yy?>.startDuration = 1;
                           chart<?=$yy?>.depth3D = 50;
                           chart<?=$yy?>.angle = 30;
                           chart<?=$yy?>.marginRight = -45;
                           chart<?=$yy?>.type="serial";
                           chart<?=$yy?>.theme="light";
       
                          //chart<?=$yy?>.creditsPosition = 'top-right';
                          chart<?=$yy?>.export =  {
                                            "enabled": true
                                          };

                            chart<?=$yy?>.numberFormatter = {
                              precision:2,decimalSeparator:",",thousandsSeparator:"."
                            };

                           // AXES
                           // category
                           var categoryAxis<?=$yy?> = chart<?=$yy?>.categoryAxis;
                           categoryAxis<?=$yy?>.gridAlpha = 0;
                           categoryAxis<?=$yy?>.axisAlpha = 0;
                           categoryAxis<?=$yy?>.gridPosition = "start";

                           // value
                           var valueAxis<?=$yy?> = new AmCharts.ValueAxis();
                           valueAxis<?=$yy?>.axisAlpha = 0;
                           valueAxis<?=$yy?>.gridAlpha = 0.1;
                           chart<?=$yy?>.addValueAxis(valueAxis<?=$yy?>);

                           <?
                           $inicio = $item_paginacao["inicio"];
                           $fim = $item_paginacao["fim"];
                           
                           for ( $i =$inicio ; $i < $fim ; $i++ ){ 

                               $item_unidade = $ls_unidade[$i];
                               $cor = inc_graficos_consulta::getHtmlColorRandom($i);

                               $nome_unidade = $item_unidade["nome"];
                               $campo_value = "value_".$item_unidade["id"];

                               $index= $i+1;
                               ?>
                             var graph<?=$index?> = new AmCharts.AmGraph();
                                       graph<?=$index?>.type = "column";
                                       graph<?=$index?>.title = "<?=$nome_unidade?>";
                                       graph<?=$index?>.valueField = "<?=$campo_value ?>";
                                       graph<?=$index?>.balloonText = "<?=$nome_unidade?>: [[value]]";
                                       graph<?=$index?>.lineAlpha = 0;
                                       graph<?=$index?>.fillColors = "<?=$cor?>";
                                       graph<?=$index?>.fillAlphas = 1;
                                       graph<?=$index?>.labelText = '[[value]]'; // this will insert values in labels 
                                       graph<?=$index?>.labelPosition = 'top';
                                       
                                       <?php if ( ($fim - $inicio) < 4 ) { ?>
                                             // graph<?=$index?>.fixedColumnWidth= 40;
                                       <?php } ?>       
                                       chart<?=$yy?>.addGraph(graph<?=$index?>);
                                       
                                       
                           <? } ?>

                           // CURSOR
                          // var chartCursor = new AmCharts.ChartCursor();
                          // chartCursor.cursorAlpha = 0;
                          // chartCursor.zoomable = false;
                          // chartCursor.categoryBalloonEnabled = false;
                          // chartCursor.valueLineEnabled = true;
                          // chartCursor.valueLineBalloonEnabled = true;
                          // chartCursor.valueLineAlpha = 1;
                          // chart.addChartCursor(chartCursor);

                             var legend<?=$yy?> = new AmCharts.AmLegend();
                            chart<?=$yy?>.addLegend(legend<?=$yy?>);

                            chart<?=$yy?>.creditsPosition = "top-right";

                            // WRITE
                            chart<?=$yy?>.write("chartdiv<?=$yy?>");
                       });

            */
</script>